'use client';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { opacity, slideUp } from './anim';

const words = [
  "नमस्ते",  // Hindi
  "Hello",    // English
  "হ্যালো",   // Bengali
  "வணக்கம்",  // Tamil
  "హలో",    // Telugu
  "ഹലോ",    // Malayalam
  "નમસ્તે",  // Gujarati
  "ਸਤ ਸ੍ਰੀ ਅਕਾਲ",  // Punjabi
  "ಹಲೋ",    // Kannada
  "ନମସ୍କାର",  // Odia
];

export default function Index() {
    const [index, setIndex] = useState(0);
    const [dimension, setDimension] = useState({width: 0, height: 0});

    useEffect(() => {
        setDimension({width: window.innerWidth, height: window.innerHeight});
    }, []);

    useEffect(() => {
        if (index === words.length - 1) return;
        setTimeout(() => {
            setIndex(index + 1);
        }, index === 0 ? 1000 : 150);
    }, [index]);

    const initialPath = `M0 0 L${dimension.width} 0 L${dimension.width} ${dimension.height} Q${dimension.width / 2} ${dimension.height + 300} 0 ${dimension.height}  L0 0`;
    const targetPath = `M0 0 L${dimension.width} 0 L${dimension.width} ${dimension.height} Q${dimension.width / 2} ${dimension.height} 0 ${dimension.height}  L0 0`;

    const curve = {
        initial: {
            d: initialPath,
            transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1] }
        },
        exit: {
            d: targetPath,
            transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.3 }
        }
    };

    return (
        <motion.div variants={slideUp} initial="initial" exit="exit" className="h-screen w-screen flex items-center justify-center fixed z-50 bg-light dark:bg-dark">
            {dimension.width > 0 && (
                <>
                    <motion.p variants={opacity} initial="initial" animate="enter" className="text-dark dark:text-light text-4xl absolute z-10 flex items-center">
                        <span className="block w-2.5 h-2.5 bg-dark dark:bg-light rounded-full mr-2"></span>{words[index]}
                    </motion.p>
                    <svg className="absolute top-0 w-full h-[calc(100%+300px)]">
                        <motion.path variants={curve} initial="initial" exit="exit" className="fill-light dark:fill-dark"></motion.path>
                    </svg>
                </>
            )}
        </motion.div>
    );
}
